import AHttpService from '@d-services/a-http-service/a-http-service';
import { addObjectToFormData } from '@d-shared/forms/forms';
import DropdownOptionsHelper from '@d-helpers/dropdown-options-helper';
import URLS from '@d-shared/urls/urls';

class ActivityFeedService extends AHttpService {
  async addPost(postData) {
    const formData = new FormData();
    addObjectToFormData(postData, formData);

    const response = await this._http.post(URLS.api.activityFeed.feed, formData);
    return response.data;
  }

  async addPostUpvote(postSlug) {
    const url = URLS.api.activityFeed.postUpvote.replace('<post-slug>', postSlug);
    const response = await this._http.post(url, null);
    return response.data;
  }

  async deletePost(postSlug) {
    const url = URLS.api.activityFeed.feedPost.replace('<post-slug>', postSlug);
    const response = await this._http.delete(url);
    return response.data;
  }

  async getBookActivities(bookSlug, page = 1) {
    const url = `${ URLS.api.activityFeed.bookActivities.replace('<book-slug>', bookSlug) }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getBookActivitiesCount(bookSlug) {
    const url = `${ URLS.api.activityFeed.bookActivitiesCount.replace('<book-slug>', bookSlug) }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getBookMentions(bookSlug) {
    const url = URLS.api.activityFeed.bookMentions.replace('<book-slug>', bookSlug);
    const response = await this._http.get(url);
    return response.data;
  }

  async getBookMentionsCount(bookSlug) {
    const url = `${ URLS.api.activityFeed.bookMentionsCount.replace('<book-slug>', bookSlug) }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getFeed(page = 1) {
    const url = `${ URLS.api.activityFeed.feed }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getPostReportReasons() {
    const response = await this._http.get(URLS.api.activityFeed.postReportReasons);
    const reportReasons = DropdownOptionsHelper.getTwoLevelOptionsListFromStrings(response.data);
    return reportReasons;
  }

  async getPostUpvotes(postSlug, page = 1) {
    const url = `${ URLS.api.activityFeed.postUpvotes.replace('<post-slug>', postSlug) }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getSidebarFeed(beforeId = null) {
    let url = URLS.api.activityFeed.sidebarFeed;
    if (beforeId) {
      url += `?before_id=${ beforeId }`;
    }

    const response = await this._http.get(url);
    return response.data;
  }

  async getUserActivities(userSlug, page = 1) {
    const url = `${ URLS.api.activityFeed.userActivities.replace('<user-slug>', userSlug) }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async pickPostOption(postSlug, option) {
    const postData = {
      option: option,
    };

    const formData = new FormData();
    addObjectToFormData(postData, formData);

    const url = URLS.api.activityFeed.pickPostOption.replace('<post-slug>', postSlug);
    const response = await this._http.post(url, formData);
    return response.data;
  }

  async removePostUpvote(postSlug) {
    const url = URLS.api.activityFeed.postUpvote.replace('<post-slug>', postSlug);
    const response = await this._http.delete(url);
    return response.data;
  }

  async reportPost(postSlug, parentReason, childReason, description) {
    const url = URLS.api.activityFeed.reportPost.replace('<post-slug>', postSlug);

    const reportData = {
      post_report: {
        description: description,
        reason: childReason ? `${ parentReason }: ${ childReason }` : parentReason,
      },
    };

    const formData = new FormData();
    addObjectToFormData(reportData, formData);

    const response = await this._http.post(url, formData);
    return response.data;
  }

  async updatePost(postSlug, postData) {
    const url = URLS.api.activityFeed.feedPost.replace('<post-slug>', postSlug);
    const formData = new FormData();
    addObjectToFormData(postData, formData);

    const response = await this._http.put(url, formData);
    return response.data;
  }
}

export default new ActivityFeedService();
